import { css, html } from 'react-strict-dom';

import { Api } from '../../../api';
import { Text } from '../../../components';
import { APP_ENV } from '../../../config';
import UploadCard from './UploadCard';

type Props = Readonly<{
  uploads: ReadonlyArray<Api.Upload.BaseView>;
  style?: css.StyleXStyles;
}>;

export default function UploadsList({ uploads, style }: Props) {
  if (uploads.length === 0) return null;

  return (
    <html.div style={style}>
      <Text as="p" style={styles.label}>
        Uploads
      </Text>
      <html.div style={styles.list}>
        {uploads.map((upload, i) => {
          const { filePath } = upload;
          if (!filePath) return null;

          // Fix file links breaking with e.g. a # in the name
          const parts = filePath.split('/');
          parts[parts.length - 1] = encodeURIComponent(parts[parts.length - 1]);
          const encodedFilePath = parts.join('/');

          // Better to use originalName as legacy Oneup files were all jpg
          const nameToCheck = upload.file.originalName ?? encodedFilePath;
          const url = `https://m10c-${APP_ENV}-pub.s3.amazonaws.com/uploads/file${encodedFilePath}`;
          const extension = nameToCheck.split('.').pop() ?? '';
          const isImage = ['gif', 'jpg', 'jpeg', 'png'].includes(
            extension.toLowerCase()
          );

          return (
            <UploadCard
              key={`${filePath}${i}`}
              originalName={upload.file.originalName}
              thumbUrl={isImage ? url : undefined}
              url={url}
            />
          );
        })}
      </html.div>
    </html.div>
  );
}

const styles = css.create({
  label: {
    marginTop: 30,
    marginBottom: 0,
    marginInline: 0,
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: 10,
    marginTop: 5,
    marginBottom: 5,
  },
});
